// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Flatlogic Dashboards (https://flatlogic.com/admin-dashboards)
 *
 * Copyright © 2015-present Flatlogic, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/*
 * Typography
 * ======================================================================== */
 :root {
  /* Site color palette */
  --color-dark-green: #1f7c50;
  --color-mint: #07ffa9;
  --color-dark: #101413;
  --color-sage: #accbc3;

  --font-size-base: 1rem;
  --font-size-lg: 1.25rem;
  --font-size-sm: 0.875rem;
  --font-size-large: 1.1rem;
  --font-size-small: 0.9rem;
  --font-size-index: 0.7rem;
  --font-family-base: 'Nunito', 'HelveticaNeue-Light', sans-serif;
  
  --line-height-computed: 1.5rem;
  
  --font-weight-thin: 300;
  --font-weight-normal: 400;
  --font-weight-semi-bold: 600;
  --font-weight-bold: 700;
  
  --gray-100: #f9f6f2;
  --gray-200: #f7f7f7;
  --gray-300: #cccbca;
  --gray-400: #ccc;
  --gray-500: #666;
  --gray-600: #6c757d;
  --gray-700: #4d4d4d;
  --gray-800: #343a40;
  --gray-900: #212529;
  
  --gray-light: var(--gray-100);
  --text-muted: var(--gray-300);


    --blue: #007bff;
    --indigo: #6610f2;
    --purple: #6f42c1;
    --pink: #e83e8c;
    --red: #dc3545;
    --orange: #fd7e14;
    --yellow: #ffc107;
    --green: var(--color-dark-green);
    --teal: var(--color-mint);
    --cyan: #17a2b8;
    --white: #fff;
    --gray: #6c757d;
    --gray-dark: var(--color-dark);
    --primary: var(--color-dark-green);
    --secondary: var(--color-sage);
    --success: var(--color-dark-green);
    --info: #5d80f9;
    --warning: #f3c363;
    --danger: #eb3349;
    --light: var(--color-sage);
    --dark: var(--color-dark);
    --inverse: var(--color-dark);
    --gray: #ccc;
    --default: #f8f8f8;
    --accent: var(--color-mint);
    --breakpoint-xs: 0;
    --breakpoint-sm: 576px;
    --breakpoint-md: 768px;
    --breakpoint-lg: 992px;
    --breakpoint-xl: 1200px;
    --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;

  
  --brand-primary: var(--color-dark-green);
  --brand-secondary: var(--color-sage);
  --brand-success: var(--color-dark-green);
  --brand-info: #5d80f9;
  --brand-warning: #f3c363;
  --brand-danger: #eb3349;
  --brand-accent: var(--color-mint);

  --text-color: var(--gray-700);
  --link-color: var(--color-mint);
  
  --alert-success-bg: #e6fff2;
  --alert-success-text: var(--brand-success);
  --alert-success-border: rgba(var(--alert-success-text), 0.15);
  
  --alert-info-bg: #d2f1fb;
  --alert-info-text: var(--link-color);
  --alert-info-border: rgba(var(--alert-info-text), 0.09);
  
  --alert-warning-bg: #fff8e6;
  --alert-warning-text: darken(var(--brand-warning), 5%);
  --alert-warning-border: rgba(var(--brand-warning), 0.2);
  
  --alert-danger-bg: #fbdcd7;
  --alert-danger-text: var(--brand-danger);
  --alert-danger-border: rgba(var(--alert-danger-text), 0.09);
  
  /* Gradients */
  --logo-gradient: linear-gradient(to right, var(--brand-danger), #f45c43);
  
  /* Iconography */
  --icon-font-path: '../../node_modules/bootstrap-sass/assets/fonts/bootstrap/'; /* overriding bootstrap variable */
  
  /*
   * Layout
   * ======================================================================== */
  
  --max-content-width: 1000px;
  
  --grid-float-breakpoint: 0;
  
  --body-bg: var(--gray-200);
  
  /*
   * Media queries breakpoints
   * ======================================================================== */
  
  --screen-xs-min: 480px;  /* Extra small screen / phone */
  --screen-sm-min: 768px;  /* Small screen / tablet */
  --screen-md-min: 992px;  /* Medium screen / desktop */
  --screen-lg-min: 1200px; /* Large screen / wide desktop */
  
  /* Components */
  
  --content-padding-horizontal: 30px;
  --content-padding-vertical: 40px;
  
  --navbar-bg-color: #fff;
  --navbar-height: 75px;
  --navbar-border-radius: 0;
  --navbar-margin-bottom: calc(-1 * var(--navbar-height));
  
  --sidebar-width-open: 235px;
  --sidebar-transition-time: 0.3s;
  
  --sidebar-bg-color: #fff;
  --sidebar-color: #4d4d4d;
  
  --breadcrumb-separator: '>';
  --breadcrumb-padding-horizontal: 0;
  
  --badge-font-weight: 600;
  
  --breadcrumb-divider: '>';
  --breadcrumb-padding-y: 0;
  --breadcrumb-padding-x: 0;
  --breadcrumb-bg: transparent;
  
  --widget-bg: #fff;
  --widget-title-color: #444;
  --widget-padding-y: 15px;
  --widget-padding-x: 20px;
  
  --btn-inverse-color: #fff;
  --btn-inverse-border: #414749;
  
  --input-height-small: 2rem;
  
  --enable-rounded: false;
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF;;6EAE6E;CAC5E;EACC,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;;EAErB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,+DAA+D;;EAE/D,8BAA8B;;EAE9B,uBAAuB;EACvB,yBAAyB;EACzB,4BAA4B;EAC5B,uBAAuB;;EAEvB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,6BAA6B;EAC7B,6BAA6B;;;IAG3B,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,gCAAgC;IAChC,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,kCAAkC;IAClC,8BAA8B;IAC9B,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,0BAA0B;IAC1B,yBAAyB;IACzB,4BAA4B;IAC5B,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,+MAA+M;IAC/M,6GAA6G;;;EAG/G,wCAAwC;EACxC,oCAAoC;EACpC,wCAAwC;EACxC,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,iCAAiC;;EAEjC,6BAA6B;EAC7B,+BAA+B;;EAE/B,2BAA2B;EAC3B,0CAA0C;EAC1C,6DAA6D;;EAE7D,wBAAwB;EACxB,oCAAoC;EACpC,uDAAuD;;EAEvD,2BAA2B;EAC3B,sDAAsD;EACtD,uDAAuD;;EAEvD,0BAA0B;EAC1B,wCAAwC;EACxC,2DAA2D;;EAE3D,cAAc;EACd,wEAAwE;;EAExE,gBAAgB;EAChB,6EAA6E,EAAE,kCAAkC;;EAEjH;;+EAE6E;;EAE7E,2BAA2B;;EAE3B,0BAA0B;;EAE1B,0BAA0B;;EAE1B;;+EAE6E;;EAE7E,sBAAsB,GAAG,+BAA+B;EACxD,sBAAsB,GAAG,0BAA0B;EACnD,sBAAsB,GAAG,4BAA4B;EACrD,uBAAuB,EAAE,gCAAgC;;EAEzD,eAAe;;EAEf,kCAAkC;EAClC,gCAAgC;;EAEhC,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,uDAAuD;;EAEvD,2BAA2B;EAC3B,+BAA+B;;EAE/B,wBAAwB;EACxB,wBAAwB;;EAExB,2BAA2B;EAC3B,kCAAkC;;EAGlC,wBAAwB;;EAExB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,4BAA4B;;EAE5B,iBAAiB;EACjB,0BAA0B;EAC1B,wBAAwB;EACxB,wBAAwB;;EAExB,yBAAyB;EACzB,6BAA6B;;EAE7B,0BAA0B;;EAE1B,uBAAuB;AACzB","sourcesContent":["/*\r\n * Flatlogic Dashboards (https://flatlogic.com/admin-dashboards)\r\n *\r\n * Copyright © 2015-present Flatlogic, LLC. All rights reserved.\r\n *\r\n * This source code is licensed under the MIT license found in the\r\n * LICENSE.txt file in the root directory of this source tree.\r\n */\r\n\r\n/*\r\n * Typography\r\n * ======================================================================== */\r\n :root {\r\n  /* Site color palette */\r\n  --color-dark-green: #1f7c50;\r\n  --color-mint: #07ffa9;\r\n  --color-dark: #101413;\r\n  --color-sage: #accbc3;\r\n\r\n  --font-size-base: 1rem;\r\n  --font-size-lg: 1.25rem;\r\n  --font-size-sm: 0.875rem;\r\n  --font-size-large: 1.1rem;\r\n  --font-size-small: 0.9rem;\r\n  --font-size-index: 0.7rem;\r\n  --font-family-base: 'Nunito', 'HelveticaNeue-Light', sans-serif;\r\n  \r\n  --line-height-computed: 1.5rem;\r\n  \r\n  --font-weight-thin: 300;\r\n  --font-weight-normal: 400;\r\n  --font-weight-semi-bold: 600;\r\n  --font-weight-bold: 700;\r\n  \r\n  --gray-100: #f9f6f2;\r\n  --gray-200: #f7f7f7;\r\n  --gray-300: #cccbca;\r\n  --gray-400: #ccc;\r\n  --gray-500: #666;\r\n  --gray-600: #6c757d;\r\n  --gray-700: #4d4d4d;\r\n  --gray-800: #343a40;\r\n  --gray-900: #212529;\r\n  \r\n  --gray-light: var(--gray-100);\r\n  --text-muted: var(--gray-300);\r\n\r\n\r\n    --blue: #007bff;\r\n    --indigo: #6610f2;\r\n    --purple: #6f42c1;\r\n    --pink: #e83e8c;\r\n    --red: #dc3545;\r\n    --orange: #fd7e14;\r\n    --yellow: #ffc107;\r\n    --green: var(--color-dark-green);\r\n    --teal: var(--color-mint);\r\n    --cyan: #17a2b8;\r\n    --white: #fff;\r\n    --gray: #6c757d;\r\n    --gray-dark: var(--color-dark);\r\n    --primary: var(--color-dark-green);\r\n    --secondary: var(--color-sage);\r\n    --success: var(--color-dark-green);\r\n    --info: #5d80f9;\r\n    --warning: #f3c363;\r\n    --danger: #eb3349;\r\n    --light: var(--color-sage);\r\n    --dark: var(--color-dark);\r\n    --inverse: var(--color-dark);\r\n    --gray: #ccc;\r\n    --default: #f8f8f8;\r\n    --accent: var(--color-mint);\r\n    --breakpoint-xs: 0;\r\n    --breakpoint-sm: 576px;\r\n    --breakpoint-md: 768px;\r\n    --breakpoint-lg: 992px;\r\n    --breakpoint-xl: 1200px;\r\n    --font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\r\n    --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\r\n\r\n  \r\n  --brand-primary: var(--color-dark-green);\r\n  --brand-secondary: var(--color-sage);\r\n  --brand-success: var(--color-dark-green);\r\n  --brand-info: #5d80f9;\r\n  --brand-warning: #f3c363;\r\n  --brand-danger: #eb3349;\r\n  --brand-accent: var(--color-mint);\r\n\r\n  --text-color: var(--gray-700);\r\n  --link-color: var(--color-mint);\r\n  \r\n  --alert-success-bg: #e6fff2;\r\n  --alert-success-text: var(--brand-success);\r\n  --alert-success-border: rgba(var(--alert-success-text), 0.15);\r\n  \r\n  --alert-info-bg: #d2f1fb;\r\n  --alert-info-text: var(--link-color);\r\n  --alert-info-border: rgba(var(--alert-info-text), 0.09);\r\n  \r\n  --alert-warning-bg: #fff8e6;\r\n  --alert-warning-text: darken(var(--brand-warning), 5%);\r\n  --alert-warning-border: rgba(var(--brand-warning), 0.2);\r\n  \r\n  --alert-danger-bg: #fbdcd7;\r\n  --alert-danger-text: var(--brand-danger);\r\n  --alert-danger-border: rgba(var(--alert-danger-text), 0.09);\r\n  \r\n  /* Gradients */\r\n  --logo-gradient: linear-gradient(to right, var(--brand-danger), #f45c43);\r\n  \r\n  /* Iconography */\r\n  --icon-font-path: '../../node_modules/bootstrap-sass/assets/fonts/bootstrap/'; /* overriding bootstrap variable */\r\n  \r\n  /*\r\n   * Layout\r\n   * ======================================================================== */\r\n  \r\n  --max-content-width: 1000px;\r\n  \r\n  --grid-float-breakpoint: 0;\r\n  \r\n  --body-bg: var(--gray-200);\r\n  \r\n  /*\r\n   * Media queries breakpoints\r\n   * ======================================================================== */\r\n  \r\n  --screen-xs-min: 480px;  /* Extra small screen / phone */\r\n  --screen-sm-min: 768px;  /* Small screen / tablet */\r\n  --screen-md-min: 992px;  /* Medium screen / desktop */\r\n  --screen-lg-min: 1200px; /* Large screen / wide desktop */\r\n  \r\n  /* Components */\r\n  \r\n  --content-padding-horizontal: 30px;\r\n  --content-padding-vertical: 40px;\r\n  \r\n  --navbar-bg-color: #fff;\r\n  --navbar-height: 75px;\r\n  --navbar-border-radius: 0;\r\n  --navbar-margin-bottom: calc(-1 * var(--navbar-height));\r\n  \r\n  --sidebar-width-open: 235px;\r\n  --sidebar-transition-time: 0.3s;\r\n  \r\n  --sidebar-bg-color: #fff;\r\n  --sidebar-color: #4d4d4d;\r\n  \r\n  --breadcrumb-separator: '>';\r\n  --breadcrumb-padding-horizontal: 0;\r\n  --breadcrumb-bg: transparent;\r\n  \r\n  --badge-font-weight: 600;\r\n  \r\n  --breadcrumb-divider: '>';\r\n  --breadcrumb-padding-y: 0;\r\n  --breadcrumb-padding-x: 0;\r\n  --breadcrumb-bg: transparent;\r\n  \r\n  --widget-bg: #fff;\r\n  --widget-title-color: #444;\r\n  --widget-padding-y: 15px;\r\n  --widget-padding-x: 20px;\r\n  \r\n  --btn-inverse-color: #fff;\r\n  --btn-inverse-border: #414749;\r\n  \r\n  --input-height-small: 2rem;\r\n  \r\n  --enable-rounded: false;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
